import * as ActionType from "./currency.type";
const initialState = {
    currency: [],
    defaultCurrency : []
};
export const currencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.GET_CURRENCY:
            return {
                ...state,
                currency: action.payload,
            };

            case ActionType.GET_DEFAULT_CURRENCY:
                return {
                    ...state,
                    defaultCurrency: action.payload,
                };

        case ActionType.CREATE_CURRENCY:
            const currentCurrency = Array.isArray(state.currency) ? state.currency : [];
            const updatedCurrency = [action.payload, ...currentCurrency];

            return {
                ...state,
                currency: updatedCurrency,
            };

        case ActionType.UPDATE_CURRENCY:
            return {
                ...state,
                currency: state.currency.map((data) =>
                    data._id === action.payload.id ? action.payload.data : data
                ),
            };

        case ActionType.DELETE_CURRENCY:
            return {
                ...state,
                currency: state.currency.filter(
                    (data) => data._id !== action.payload && data
                ),
            };
        case ActionType.DEFAULT_CURRENCY:
                // Keep default selection deterministic without mutating arrays or double overwrites.
                if (!action.payload || !action.payload.data) {
                  return state;
                }

                if (Array.isArray(action.payload.data)) {
                  const nextDefault =
                    action.payload.data.find((item) => item?._id === action.payload.id) ||
                    state.defaultCurrency;
                  return {
                    ...state,
                    currency: action.payload.data,
                    defaultCurrency: nextDefault,
                  };
                }

                return {
                  ...state,
                  currency: state.currency.map((data) =>
                    data?._id === action.payload.id ? action.payload.data : data
                  ),
                  defaultCurrency: action.payload.data,
                };
              

        default:
            return state;
    }
};
